import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen" }
const _hoisted_2 = { class: "mt-8 space-y-5" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-20 text-slate-400"
}
const _hoisted_4 = { class: "flex flex-col gap-1.5 sm:max-w-xs" }
const _hoisted_5 = { class: "grid gap-4 sm:grid-cols-2 xl:grid-cols-3" }
const _hoisted_6 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_7 = { class: "mt-3 text-2xl font-bold text-slate-900" }
const _hoisted_8 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_9 = { class: "mt-3 text-2xl font-bold text-slate-900" }
const _hoisted_10 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_11 = { class: "mt-3 text-2xl font-bold text-slate-900" }
const _hoisted_12 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_13 = { class: "mt-3 text-2xl font-bold text-slate-900" }
const _hoisted_14 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_15 = { class: "mt-3 text-2xl font-bold text-green-700" }
const _hoisted_16 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_17 = { class: "mt-3 text-2xl font-bold text-slate-900" }
const _hoisted_18 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_19 = {
  key: 1,
  class: "text-sm text-slate-400"
}
const _hoisted_20 = { class: "rounded-2xl border border-slate-200 bg-white shadow-sm overflow-hidden" }
const _hoisted_21 = { class: "min-w-full text-sm" }
const _hoisted_22 = { class: "divide-y divide-slate-100" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "px-5 py-4 text-slate-500" }
const _hoisted_25 = { class: "px-5 py-4 font-medium text-slate-900" }
const _hoisted_26 = { class: "px-5 py-4" }
const _hoisted_27 = { class: "rounded-full bg-blue-100 px-2 py-0.5 text-xs font-semibold text-blue-800" }
const _hoisted_28 = { class: "px-5 py-4 text-slate-600" }
const _hoisted_29 = { class: "px-5 py-4 text-slate-600" }
const _hoisted_30 = { class: "px-5 py-4 font-semibold text-slate-900" }
const _hoisted_31 = { class: "px-5 py-4 font-semibold text-slate-900" }
const _hoisted_32 = { class: "px-5 py-4 font-semibold text-green-700" }
const _hoisted_33 = { class: "px-5 py-4 font-semibold text-slate-900" }

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { GET_MERCHANDISES } from '@/store/merchandise.module';
import { GET_TRANSACTIONS } from '@/store/transaction.module';
import Breadcrumb from '@/components/AppBreadcrumb.vue';
import AppSelect from '@/components/input/AppSelect.vue';
import type { Merchandise, Transaction } from '@/types/domain';

type TopMerchandise = Merchandise & {
  totalTerjual: number;
  totalPendapatan: number;
  totalHpp: number;
  labaKotor: number;
  marginKotor: number;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'MerchandiseDashboardView',
  setup(__props) {

const store = useStore();
const isLoading = ref(true);
const selectedKategori = ref('Semua');

const merchandises = computed<Merchandise[]>(() => store.getters.merchandises?.data || []);
const transactions = computed<Transaction[]>(() => store.getters.transactions || []);

const allKategori = computed<string[]>(() => {
  const cats = merchandises.value
    .map((m) => m.kategori)
    .filter((category): category is string => Boolean(category?.trim()));
  return [...new Set(cats)].sort();
});
const kategoriFilterOptions = computed(() => [
  { value: 'Semua', label: 'Semua Kategori' },
  ...allKategori.value.map((kategori) => ({ value: kategori, label: kategori })),
]);

const filteredMerchandises = computed(() =>
  selectedKategori.value === 'Semua'
    ? merchandises.value
    : merchandises.value.filter((m) => m.kategori === selectedKategori.value)
);

const filteredMerchIds = computed(() =>
  new Set(filteredMerchandises.value.map((m) => m.id).filter((id): id is number => typeof id === 'number'))
);

const filteredTransactions = computed(() =>
  transactions.value.filter((t) => filteredMerchIds.value.has(t.merchandiseId) && t.paymentStatus === 'settlement')
);

const merchMap = computed<Map<number, Merchandise>>(() =>
  new Map(
    merchandises.value
      .filter((m): m is Merchandise & { id: number } => typeof m.id === 'number')
      .map((m) => [m.id, m])
  )
);

const totalTerjual = computed(() =>
  filteredTransactions.value.reduce((sum, t) => sum + (Number(t.qty) || 0), 0)
);

const totalPendapatan = computed(() =>
  filteredTransactions.value.reduce((sum, t) => {
    const merch = merchMap.value.get(t.merchandiseId);
    return sum + (Number(t.qty) || 0) * (Number(merch?.price) || 0);
  }, 0)
);

const totalHpp = computed(() =>
  filteredTransactions.value.reduce((sum, t) => {
    const merch = merchMap.value.get(t.merchandiseId);
    return sum + (Number(t.qty) || 0) * (Number(merch?.hpp) || 0);
  }, 0)
);

const labaKotor = computed(() => totalPendapatan.value - totalHpp.value);

const marginKotor = computed(() =>
  totalPendapatan.value > 0 ? (labaKotor.value / totalPendapatan.value) * 100 : 0
);

const chartOptions = computed(() => ({
  chart: { type: 'bar', toolbar: { show: false } },
  xaxis: { categories: allKategori.value },
  yaxis: { labels: { formatter: (v: number) => formatPrice(v) } },
  colors: ['#003793', '#15803d'],
  plotOptions: { bar: { borderRadius: 6 } },
  dataLabels: { enabled: false },
  tooltip: { y: { formatter: (v: number) => formatPrice(v) } },
}));

const chartSeries = computed(() => {
  const revenue: Record<string, number> = {};
  const profit: Record<string, number> = {};
  allKategori.value.forEach((k) => (revenue[k] = 0));
  allKategori.value.forEach((k) => (profit[k] = 0));
  filteredTransactions.value.forEach((t) => {
    const merch = merchMap.value.get(t.merchandiseId);
    const kat = merch?.kategori;
    if (kat && revenue[kat] !== undefined) {
      const qty = Number(t.qty) || 0;
      const omzet = qty * (Number(merch?.price) || 0);
      const hpp = qty * (Number(merch?.hpp) || 0);
      revenue[kat] += omzet;
      profit[kat] += omzet - hpp;
    }
  });
  return [
    { name: 'Omzet', data: allKategori.value.map((k) => revenue[k] || 0) },
    { name: 'Laba Kotor', data: allKategori.value.map((k) => profit[k] || 0) },
  ];
});

const top10 = computed<TopMerchandise[]>(() => {
  const tally: Record<number, { totalTerjual: number; totalPendapatan: number; totalHpp: number }> = {};
  filteredTransactions.value.forEach((t) => {
    const id = t.merchandiseId;
    if (typeof id !== 'number') return;
    if (!tally[id]) tally[id] = { totalTerjual: 0, totalPendapatan: 0, totalHpp: 0 };
    const merch = merchMap.value.get(id);
    const qty = Number(t.qty) || 0;
    tally[id].totalTerjual += qty;
    tally[id].totalPendapatan += qty * (Number(merch?.price) || 0);
    tally[id].totalHpp += qty * (Number(merch?.hpp) || 0);
  });
  return Object.entries(tally)
    .map(([id, stats]) => {
      const laba = stats.totalPendapatan - stats.totalHpp;
      return {
        ...(merchMap.value.get(Number(id)) || {}),
        ...stats,
        labaKotor: laba,
        marginKotor: stats.totalPendapatan > 0 ? (laba / stats.totalPendapatan) * 100 : 0,
      };
    })
    .sort((a, b) => b.totalTerjual - a.totalTerjual)
    .slice(0, 10);
});

function formatPrice(value: number | string | null | undefined) {
  return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(Number(value) || 0);
}

function formatPercent(value: number | string | null | undefined) {
  return `${new Intl.NumberFormat('id-ID', { maximumFractionDigits: 1 }).format(Number(value) || 0)}%`;
}

onMounted(async () => {
  try {
    await Promise.all([
      store.dispatch(GET_MERCHANDISES, { data: { limit: 1000 } }),
      store.dispatch(GET_TRANSACTIONS, { data: { limit: 1000 } }),
    ]);
  } catch (err) {
    console.error('Failed to load dashboard data:', err);
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Breadcrumb, { breadcrumb: "Dashboard Merchandise" }),
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createStaticVNode("<section class=\"relative overflow-hidden rounded-2xl bg-[#003793] p-4 text-white shadow-sm sm:p-6\"><div class=\"absolute -right-10 -top-12 h-40 w-40 rounded-full bg-white opacity-10\"></div><div class=\"absolute bottom-0 right-20 h-24 w-24 rounded-full bg-blue-300 opacity-10\"></div><div class=\"relative\"><h1 class=\"text-2xl font-bold md:text-4xl\">Dashboard Penjualan Merchandise</h1><p class=\"mt-2 text-sm text-blue-100\"> Pantau penjualan merchandise, HPP, laba kotor, dan margin berdasarkan transaksi berhasil. </p></div></section>", 1)),
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, "Memuat data..."))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-sm font-semibold text-slate-900" }, "Filter Kategori", -1)),
              _createVNode(AppSelect, {
                modelValue: selectedKategori.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedKategori).value = $event)),
                options: kategoriFilterOptions.value,
                "button-class": "min-w-[180px] bg-white text-slate-800"
              }, null, 8, ["modelValue", "options"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Total Produk", -1)),
                _createElementVNode("p", _hoisted_7, _toDisplayString(filteredMerchandises.value.length), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Total Terjual", -1)),
                _createElementVNode("p", _hoisted_9, _toDisplayString(totalTerjual.value) + " pcs", 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[4] || (_cache[4] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Omzet", -1)),
                _createElementVNode("p", _hoisted_11, _toDisplayString(formatPrice(totalPendapatan.value)), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Total HPP", -1)),
                _createElementVNode("p", _hoisted_13, _toDisplayString(formatPrice(totalHpp.value)), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Laba Kotor", -1)),
                _createElementVNode("p", _hoisted_15, _toDisplayString(formatPrice(labaKotor.value)), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _cache[7] || (_cache[7] = _createElementVNode("p", { class: "text-sm font-semibold text-slate-500" }, "Margin", -1)),
                _createElementVNode("p", _hoisted_17, _toDisplayString(formatPercent(marginKotor.value)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "mb-4 text-base font-bold text-slate-900" }, "Omzet dan Laba Kotor per Kategori", -1)),
              (chartSeries.value[0].data.length)
                ? (_openBlock(), _createBlock(_component_apexchart, {
                    key: 0,
                    type: "bar",
                    height: "300",
                    options: chartOptions.value,
                    series: chartSeries.value
                  }, null, 8, ["options", "series"]))
                : (_openBlock(), _createElementBlock("p", _hoisted_19, "Belum ada data transaksi."))
            ]),
            _createElementVNode("div", _hoisted_20, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "px-5 py-4 border-b border-slate-100" }, [
                _createElementVNode("h2", { class: "text-base font-bold text-slate-900" }, "Top 10 Merchandise Terlaris")
              ], -1)),
              _createElementVNode("table", _hoisted_21, [
                _cache[10] || (_cache[10] = _createElementVNode("thead", { class: "bg-slate-50" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-5 py-3 text-left text-sm font-semibold text-slate-600" }, "#"),
                    _createElementVNode("th", { class: "px-5 py-3 text-left text-sm font-semibold text-slate-600" }, "Nama"),
                    _createElementVNode("th", { class: "px-5 py-3 text-left text-sm font-semibold text-slate-600" }, "Kategori"),
                    _createElementVNode("th", { class: "px-5 py-3 text-left text-sm font-semibold text-slate-600" }, "Harga Jual"),
                    _createElementVNode("th", { class: "px-5 py-3 text-left text-sm font-semibold text-slate-600" }, "HPP/Unit"),
                    _createElementVNode("th", { class: "px-5 py-3 text-left text-sm font-semibold text-slate-600" }, "Terjual"),
                    _createElementVNode("th", { class: "px-5 py-3 text-left text-sm font-semibold text-slate-600" }, "Omzet"),
                    _createElementVNode("th", { class: "px-5 py-3 text-left text-sm font-semibold text-slate-600" }, "Laba Kotor"),
                    _createElementVNode("th", { class: "px-5 py-3 text-left text-sm font-semibold text-slate-600" }, "Margin")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_22, [
                  (top10.value.length === 0)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [...(_cache[9] || (_cache[9] = [
                        _createElementVNode("td", {
                          colspan: "9",
                          class: "px-5 py-8 text-center text-slate-400"
                        }, "Belum ada data transaksi berhasil.", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(top10.value, (item, idx) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: "hover:bg-slate-50"
                    }, [
                      _createElementVNode("td", _hoisted_24, _toDisplayString(idx + 1), 1),
                      _createElementVNode("td", _hoisted_25, _toDisplayString(item.name), 1),
                      _createElementVNode("td", _hoisted_26, [
                        _createElementVNode("span", _hoisted_27, _toDisplayString(item.kategori || '-'), 1)
                      ]),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(formatPrice(item.price)), 1),
                      _createElementVNode("td", _hoisted_29, _toDisplayString(formatPrice(item.hpp)), 1),
                      _createElementVNode("td", _hoisted_30, _toDisplayString(item.totalTerjual) + " pcs", 1),
                      _createElementVNode("td", _hoisted_31, _toDisplayString(formatPrice(item.totalPendapatan)), 1),
                      _createElementVNode("td", _hoisted_32, _toDisplayString(formatPrice(item.labaKotor)), 1),
                      _createElementVNode("td", _hoisted_33, _toDisplayString(formatPercent(item.marginKotor)), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ], 64))
    ])
  ]))
}
}

})